import endpoints, { axios } from "../config/api";

function getAddableDependancyTemplateTasks(taskTemplateId: number) {
  return axios.get(
    endpoints.taskTemplates.getAddableTaskDependancies(taskTemplateId)
  );
}

export default getAddableDependancyTemplateTasks;
